import React, { useState } from "react";
import { currentCountry } from "../utils";

export default function LocaleImage ({
    url,
    ext,
    style
}: {
    url: string
    ext: "png"|"jpg"
    style?: React.CSSProperties
}) {
    const [country, setCountry] = useState<string>(currentCountry().toLowerCase())
    const [loaded, setLoaded] = useState<boolean>(false)
    
    const errorHandler = () => {
        if (country !== "global")
            setCountry("global")
    }

    const loadHandler = () => {
        setLoaded(true)
    }

    const styleExtensions : React.CSSProperties = {
        opacity: (loaded ? 1 : 0)
    }

    return (
        <img src={`${url}${country}.${ext}`} style={{...style, ...styleExtensions}} onError={errorHandler} onLoad={loadHandler} />
    )
}